export enum Workflow {
  RegistrationStatus = 'REGISTRATION_STATUS',
  Eligibility = 'ELIGIBILITY',
}
